import React from 'react';
import styled from 'styled-components';

import { HeaderContainer, HeaderMixin } from '../../shared/styles';
import {
  ActionColumn,
  NameColumn,
  CompanyColumn,
  PartnershipTypeColumn,
  StatusColumn,
} from './styles';
import FundsContext from './context';

const NameColumnHeader = styled(NameColumn)`
  ${HeaderMixin}
  display: flex;
  flex-direction: column;
`;

const CompanyColumnHeader = styled(CompanyColumn)`
  ${HeaderMixin}
  display: flex;
  flex-direction: column;
`;

const PartnershipTypeColumnHeader = styled(PartnershipTypeColumn)`
  ${HeaderMixin}
`;

const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  span {
    width: 50%;
  }

  a {
    outline: none;
  }
`;

const StatusColumnHeader = styled(StatusColumn)`
  ${HeaderMixin}
`;

const SActionColumn = styled(ActionColumn)`
  label {
    float: right;
    margin-left: 24px;
  }
`;

const SearchInput = styled.div`
  display: none;

  &.show-filter {
    display: block;
  }

  input {
    height: 40px !important;
    padding-left: 8px !important;
  }
`;

export default function Header() {
  const [showFilterOnCompanyName, setShowFilterOnCompanyName] = React.useState(false);
  const [showFilterOnName, setShowFilterOnName] = React.useState(false);
  const { state, dispatch } = React.useContext(FundsContext);

  const toggleShowHideUnpublishedFunds = () => {
    dispatch({ type: 'setShowUnpublishedFunds', payload: !state.showUnpublishedFunds });
  };

  const toggleShowHideHasDataReviewFunds = () => {
    dispatch({ type: 'setShowHasDataReviewFunds', payload: !state.showHasDataReviewFunds });
  };

  const toggleShowHideFilterOnCompanyName = e => {
    e && e.preventDefault();

    if (showFilterOnCompanyName) {
      dispatch({ type: 'setFilterByCompanyName', payload: '' });
    }

    setShowFilterOnCompanyName(!showFilterOnCompanyName);
  };

  const toggleShowHideFilterOnName = e => {
    e && e.preventDefault();

    if (showFilterOnName) {
      dispatch({ type: 'setFilterByName', payload: '' });
    }

    setShowFilterOnName(!showFilterOnName);
  };

  const filterByName = e => {
    dispatch({ type: 'setFilterByName', payload: e.target.value });
  };

  const filterByCompanyName = e => {
    dispatch({ type: 'setFilterByCompanyName', payload: e.target.value });
  };

  return (
    <HeaderContainer>
      <NameColumnHeader>
        <HeaderTitle>
          <span>Name</span>
          <a href="#" onClick={toggleShowHideFilterOnName}><span className="pe-7s-filter" /></a>
        </HeaderTitle>
        <SearchInput className={`form-group ${showFilterOnName ? 'show-filter' : ''}`}>
          <input name="nameFilter" value={state.queryOnName} onChange={filterByName} />
        </SearchInput>
      </NameColumnHeader>
      <CompanyColumnHeader>
        <HeaderTitle>
          <span>Company</span>
          <a href="#" onClick={toggleShowHideFilterOnCompanyName}><span className="pe-7s-filter" /></a>
        </HeaderTitle>
        <SearchInput className={`form-group ${showFilterOnCompanyName ? 'show-filter' : ''}`}>
          <input name="companyNameFilter" value={state.queryOnCompanyName} onChange={filterByCompanyName} />
        </SearchInput>
      </CompanyColumnHeader>
      <PartnershipTypeColumnHeader>Partner Type</PartnershipTypeColumnHeader>
      <StatusColumnHeader>Status</StatusColumnHeader>
      <SActionColumn>
        <label htmlFor="show-unpublished">
          <input
            id="show-unpublished"
            type="checkbox"
            checked={state.showUnpublishedFunds}
            onChange={toggleShowHideUnpublishedFunds}
          />
          Show unpublished
        </label>
        <label htmlFor="show-review">
          <input
            id="show-review"
            type="checkbox"
            checked={state.showHasDataReviewFunds}
            onChange={toggleShowHideHasDataReviewFunds}
          />
          Need review
        </label>
      </SActionColumn>
    </HeaderContainer>
  );
}
